<script>
import axios from "axios";

export default {
  props: {
    visible: {
      required: false,
      default: false,
    },
    aforo: {
      type: [Object],
      required: true,
    },
  },
  emits: ["refetch", "close-modal"],
  data() {
    return {
      selected: {
        status: undefined,
      },
    };
  },
  methods: {
    async deleteAforo() {
      try {
        await axios.delete(`/api/admin/aforos/${this.aforo.id}`);
        this.$emit("refetch");
        this.$emit("close-modal");
      } catch (e) {
        console.error(e);
        this.$swal({
          icon: "error",
          title: "Error",
          text: "Hubo un problema al eliminar el aforo.",
        });
      }
    },
  },
};
</script>

<template>
  <b-modal v-model="visible">
    <template #modal-title> Eliminar aforo </template>
    <div class="flex flex-col gap-4">
      <p>¿Estas seguro de eliminar este aforo?</p>
    </div>

    <template #modal-footer>
      <div class="flex flex-row items-center gap-2 justify-end">
        <button class="btn-cancelar" @click="() => $emit('close-modal')">
          Cancelar
        </button>
        <button class="btn-danger" @click="deleteAforo()">Eliminar</button>
      </div>
    </template>
  </b-modal>
</template>
